import HomeController from './Home';
import AccountController from './Account';
import HelpController from './Help';
import LeaguesController from './Leagues';
import MatchCentreController from './MatchCentre';
import OnboardingController from './Onboarding';
import PriceRevealController from './PriceReveal';
import StatsController from './Stats';
import FantasyController from './Fantasy';
import DraftController from './Draft';
import PulseController from './Pulse';
import GameSelectorController from './GameSelector';
import ActivateGameController from './ActivateGame';
import PasswordController from './Password';
import OffSeasonController from './OffSeason';
import FantasyCoachController from './FantasyCoach';

export { HomeController };
export { AccountController };
export { HelpController };
export { LeaguesController };
export { MatchCentreController };
export { OnboardingController };
export { PriceRevealController };
export { StatsController };
export { FantasyController };
export { DraftController };
export { PulseController }
export { GameSelectorController }
export { ActivateGameController }
export { PasswordController }

export { OffSeasonController };
export { FantasyCoachController };

export default {
	HomeController,
	AccountController,
	HelpController,
	LeaguesController,
	MatchCentreController,
	OnboardingController,
	PriceRevealController,
	StatsController,
	FantasyController,
	DraftController,
	PulseController,
	GameSelectorController,
	ActivateGameController,
	PasswordController,
	OffSeasonController,
	FantasyCoachController
}